module.exports = __webpack_public_path__ + "img/earn-reward.2c865a37.png";